<template>
  <div>
    <div class="accountset">
      <div class="global-title-one">签名报备（官方）</div>

      <div style="padding:5px 24px; 5px 24px">
        <div class="head-box">
          <!-- <img src="../../assets/images/notice.png" class="head-icon"> -->
          <div class="head-content">
            <span class="icon_i">i</span>
            <span class="block"
              >1.每个店铺只能有一个短信签名，云短信与其他系统签名同步，商家可重新申请签名，但是新签名生效后，之前的店铺签名作废。</span
            >
            <span class="block"
              >2.如果有待发送的短信任务，请务必不要更换签名， 否则可能会因签名不一致导致之前的短信任务执行失败或字数计算有误!</span
            >
          </div>
        </div>
      </div>
      <div>
        <div class="table-box" style="margin-top: 10px">
          <el-button
            style="margin-bottom: 10px"
            type="primary"
            @click="forSignature"
            v-zoom='{from:pageName,name:"申请签名"}'
            >申请签名</el-button
          >
          <p style="color: rgb(254, 77, 69); font-size: 18px; font-weight: bold; margin: 10px 0">温馨提示：如果有待发送的短信任务，请务必不要更换签名， 否则可能会因签名不一致导致之前的短信任务执行失败或字数计算有误!</p>
          <el-table
            v-loading="loading"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="light"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%; opacity: 1"
          >
            <template slot="empty">
              <div>
                <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column align="center" prop="jdSmsSuffix" label="短信签名">
              <template slot-scope="scope">
                <span>{{ scope.row.jdSmsSuffix }}</span
                >&nbsp;
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="smsTestMobiles"
              label="测试号码"
            >
              <template slot-scope="scope">
                <div style="cursor: pointer">
                  {{ scope.row.smsTestMobiles || '--' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="shopType" label="店铺类型">
              <template slot-scope="scope">
                <span>{{ scope.row.shopType }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="signStatusName"
              label="签名状态"
            >
              <template slot-scope="scope">
                <span>
                  <span
                    class="dot"
                    :class="[
                      scope.row.signStatusName == '生效中' ? 'dot-0' : '',
                      scope.row.signStatusName == '待审核' ? 'dot-1' : '',
                      scope.row.signStatusName == '已失效' ? 'dot-2' : '',
                      scope.row.signStatusName == '审核拒绝' ? 'dot-3' : '',
                    ]"
                  ></span>
                  {{ scope.row.signStatusName }}
                </span>
                <el-tooltip
                  effect="dark"
                  :content="scope.row.auditRefusedReason"
                  placement="top-start"
                >
                  <img
                    v-if="scope.row.signStatusName == '审核拒绝'"
                    src="../../assets/images/ask.png"
                    alt=""
                  />
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column align="left" prop="bindDate" label="操作">
              <template slot-scope="scope">
                <!-- 状态为默认失效 -->
                <span>
                  <span
                    type="text"
                    v-if="scope.row.signStatusName.match('已失效')"
                    class="operation"
                    v-zoom='{from:pageName,name:"失效删除"}'
                    @click="handleDelete1(scope.$index, scope.row)"
                    >删除</span
                  >
                </span>
                <!-- 审核不通过 -->
                <span v-if="scope.row.signStatusName.match('审核拒绝')">
                  <span type="text" style="color: #ccc">请重新申请</span>
                </span>
                <!-- 状态为生效中-->
                <span v-if="scope.row.signStatusName.match('生效中')">
                  <span
                    type="text"
                    v-zoom='{from:pageName,name:"生效中修改号码"}'
                    @click="modifyNumber(scope.$index, scope.row)"
                    class="operation"
                    >修改号码</span
                  >
                  <br />
                  <span
                    @click="modifySignature(scope.$index, scope.row)"
                    type="text"
                    v-zoom='{from:pageName,name:"生效中修改签名"}'
                    class="operation"
                    >修改签名</span
                  >
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="height: 200px"></div>
      </div>
      <!-- 修改签名弹窗 -->
      <el-dialog
        title="修改短信签名"
        :visible.sync="showDialog"
        width="460px"
        style="min-width: 1100px"
      >
        <template slot="title">
          <span>修改短信签名</span>
        </template>
        <div class="dialog-wrapper">
          <div class="item">
            <span class="item-title">短信签名：</span>
            <el-input
              size="small"
              class="input"
              v-model="addSeller"
              @input="cusuffixChange"
            ></el-input>
          </div>
          <div class="remarksOne">
            <p style="margin: 8px">
              1.每个商家只能创建1个签名，签名内不得包含 "京东"
              二字，云短信与其他系统官方签名同步。
            </p>
            <p style="margin: 8px">2.签名每天下午6点由京东进行审核。</p>
          </div>
          <div></div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            showDialog="showDialog"
            style="width: 96px"
            @click="showDialog = false"
            >取消</el-button
          >
          <el-button @click="submitAudit" type="primary" style="width: 96px"
            >提交</el-button
          >
        </span>
      </el-dialog>
      <!-- 申请签名弹窗 -->
      <el-dialog
        title="申请签名"
        :visible.sync="showDialogTwo"
        width="460px"
        style="min-width: 1100px"
      >
        <template slot="title">
          <span>申请签名</span>
        </template>
        <div class="dialog-wrapper">
          <div class="item">
            <span class="item-title">短信签名：</span>
            <el-input
              size="small"
              class="input"
              v-model="jdSmsSuffix"
              placeholder="请输入短信签名"
              @input="cusuffixChange"
            ></el-input>
          </div>
          <div class="item">
            <span class="item-title">短信测试：</span>
            <el-input
              size="small"
              class="input"
              v-model="smsTestMobiles"
              placeholder="请输入常用测试号码，最多3个，以','隔开"
            ></el-input>
          </div>
          <div class="remarksOne">
            <span class="icon_i">i</span>
            <div class="boxText">
              <span>
                1.每个商家只能创建1个签名，签名内不得包含 "京东"
                二字，云短信与其他系统官方签名同步。
              </span>
              <p style="margin: 10px 0">2.签名每天下午6点由京东进行审核。</p>
            </div>
          </div>
          <div></div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            showDialog="showDialog"
            style="width: 96px"
            @click="showDialogTwo = false"
            >取消</el-button
          >
          <el-button @click="createAudit" type="primary" style="width: 96px"
            >提交</el-button
          >
        </span>
      </el-dialog>
      <!-- 修改号码弹窗 -->
      <el-dialog
        title="修改短信号码"
        :visible.sync="showDialogOne"
        width="460px"
        style="min-width: 1100px"
      >
        <template slot="title">
          <span>修改短信号码</span>
        </template>
        <div class="dialog-wrapper">
          <div class="item">
            <span class="item-title">短信测试：</span>
            <el-input
              size="small"
              class="input"
              v-model="mobilPhone"
            ></el-input>
          </div>
          <div class="remarks">
            注：填写测试号码，在测试发送时无需审核短信内容。
          </div>
          <div></div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            showDialog="showDialog"
            style="width: 96px"
            @click="showDialogOne = false"
            >取消</el-button
          >
          <el-button @click="submit" type="primary" style="width: 96px"
            >提交</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 删除弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="outerVisible"
      width="400px"
      :before-close="closehandleDelete"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="margin: 6px 0px 0px 40px; position: absolute; width: 22px"
      />
      <span
        style="position: absolute; margin: 10px 0px 0px 70px; font-size: 14px"
        >是否删除此签名</span
      >
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  suffixList,
  delectNum,
  updatePrecisionJdSuffixById,
  updateSuffixMobileById,
  createPrecision,
} from "@/api/backstage/messageBill";
import topTitle from "@/components/top-title.vue";
import { mapState } from "vuex";
export default {
  name: "signature_set",
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
    addSeller: {
      get() {
        return this.addSellerCusuffix.replace(/[【】]/g, "");
      },
      set() {},
    },
  },
  components: {
    topTitle,
  },
  data() {
    return {
      pageName:"后台管理-签名报备（官方）",
      jdSmsSuffix: "",
      smsTestMobiles: "",
      showDialogTwo: false, //申请签名
      loading: false,
      nthDefault: 0,
      showDialog: false, //添加签名弹窗
      cusuffixName: "修改短信号码", //签名状态（添加/删除/编辑/默认）,
      tableData: [],
      addSellerCusuffix: "", //短信签名内容
      handleEditOb: {}, //编辑
      remarks: "",
      id: "",
      idOne: "",
      showDialogOne: false,
      mobilPhone: "",
      mobilPhone2: "",
      outerVisible: false,
      index1: "",
      row1: "",
    };
  },
  created() {},
  mounted() {
    this.queryAllSellerCusuffix();
  },
  methods: {
    //申请签名
    forSignature() {
      this.showDialogTwo = true;
      console.log("111111");
    },
    //签名时赋值
    cusuffixChange(value) {
      this.addSellerCusuffix = value.replace(/[【】]/g, "");
    },
    //签名提交按钮
    submitAudit() {
      let addSe = "【" + this.addSeller + "】";
      if (this.addSellerCusuffix == addSe) {
        this.$message.warning("签名重复");
        return;
      }
      this.addSellerCusuffix = this.addSellerCusuffix.replace(/[【】]/g, "");
      updatePrecisionJdSuffixById({
        jdSmsSuffix: this.addSellerCusuffix.trim(),
        id: this.id,
      })
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success("修改成功");
            this.showDialog = false;
            this.queryAllSellerCusuffix();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    //申请签名
    createAudit() {
      // this.addSellerCusuffix = this.addSellerCusuffix.replace(/[【】]/g, "");
      createPrecision({
        jdSmsSuffix: this.jdSmsSuffix.trim(),
        smsTestMobiles: this.smsTestMobiles,
      })
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success("申请成功");
            this.jdSmsSuffix = "";
            this.smsTestMobiles = "";
            this.showDialog = false;
            this.queryAllSellerCusuffix();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    //修改手机号码提交按钮
    submit() {
      if (this.mobilPhone == this.mobilPhone2) {
        this.$message.warning("号码重复");
        return;
      }
      updateSuffixMobileById({
        smsTestMobiles: this.mobilPhone,
        id: this.idOne,
      })
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("修改成功");
            this.showDialogOne = false;
            this.queryAllSellerCusuffix();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {});
    },
    //修改签名
    modifySignature(v, val) {
      this.addSellerCusuffix = val.jdSmsSuffix;
      this.id = val.id;
      this.showDialog = true;
    },
    //修改手机号码
    modifyNumber(v, val) {
      console.log(val);
      this.mobilPhone2 = val.smsTestMobiles;
      this.mobilPhone = val.smsTestMobiles;
      this.idOne = val.id;
      this.showDialogOne = true;
    },
    // 表格查询
    queryAllSellerCusuffix() {
      this.loading = true;
      suffixList({
        Accept: "*/*",
      }).then((res) => {
        this.tableData = res.data;
        this.loading = false;
      });
    },
    handleDelete1(index, row) {
      this.outerVisible = true;
      this.index1 = index;
      this.row1 = row;
    },
    //关闭删除弹框
    closehandleDelete() {
      this.outerVisible = false;
      this.$message.warning("已关闭删除");
    },
    //确认删除
    handleDeleteTable() {
      this.outerVisible = false;
      this.handleDelete(this.index1, this.row1);
    },

    //删除
    handleDelete(index, row) {
      delectNum({
        id: row.id,
      })
        .then((res) => {
          if (res && res.code == 1) {
            this.queryAllSellerCusuffix();
            this.$message.success("删除成功");
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => {});
    },

    // //重新提交
    // handleConfirm1111(index, row) {
    //   let resubmit = row.jdSmsSuffix.replace(/[【】]/g, "");
    //   console.log(row);
    //   updatePrecisionJdSuffixById({
    //     // sellerCusuffixId: row.sellerCusuffixId,
    //     jdSmsSuffix: resubmit,
    //     id: row.id,
    //   })
    //     .then((res) => {
    //       if (res && res.code == 1) {
    //         this.$message.success("更新成功");
    //         this.queryAllSellerCusuffix();
    //       } else {
    //         this.$message.error("更新失败");
    //       }
    //     })
    //     .catch((res) => {});
    // },
  },

  //设置默认
  // handleDefault(index, row) {
  //   updateSellerCusuffixToFirst({
  //     sellerCusuffixId: row.sellerCusuffixId,
  //   })
  //     .then((res) => {
  //       this.$message({
  //         message: "默认成功",
  //         type: "success",
  //       });
  //       this.queryAllSellerCusuffix();
  //     })
  //     .catch((e) => {});
  // },
  //编辑时间提交
  // submitEdit() {
  //   this.addSellerCusuffix = this.addSellerCusuffix.replace(/[【】]/g, "");
  //   updateSellerCusuffix({
  //     sellerCusuffixId: this.handleEditOb.row.sellerCusuffixId,
  //     newSuffix: this.addSellerCusuffix,
  //     priority: this.addSellerCusuffixNum,
  //   }).then((res) => {
  //     // this.queryAllSellerCusuffix()
  //     this.showDialog = false;
  //     this.$message({
  //       message: "编辑成功",
  //       type: "success",
  //     });
  //     this.queryAllSellerCusuffix();
  //   });
  // },
  //添加标签提交
  // submitAudit1111() {
  //   console.log("1111111111")
  //   updatePrecisionJdSuffixById({
  //     jdSmsSuffix: this.addSellerCusuffix,
  //   })
  //     .then((res) => {
  //       if (res.code == 200) {
  //       }
  //       this.showDialog = false;
  //       this.queryAllSellerCusuffix();
  //     })
  //     .catch((e) => {});
  // },
  //编辑
  // handleEdit(index, row) {
  //   // if (row.status === "审核中") {
  //   //   this.handleEditOb.status = 0;
  //   // } else {
  //   //   this.handleEditOb.status = "";
  //   // }
  //   // this.handleEditOb.index = index;
  //   // this.handleEditOb.row = row;
  //   // this.addSellerCusuffix = row.suffix;
  //   // this.addSellerCusuffixNum = row.priority;
  //   // this.cusuffixName = "编辑签名";
  //   this.showDialog = true;
  // },
};
</script>
<style scoped lang="scss">
// /deep/.el-table .cell {
//     -webkit-box-sizing: border-box;
//     box-sizing: border-box;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     white-space: normal;
//     word-break: break-all;
//     line-height: 23px;
//     padding-left: 60px;
//     padding-right: 10px;
// }
</style>
<style lang="scss">
.global-comment.el-alert {
  align-items: normal !important;
  background-color: #fff4f4;
  border: 1px solid #fe8f8a;
  /deep/.el-icon-info {
    color: #fe4d45;
    font-size: 14px;
  }

  .tip-alert {
    color: #333;
    .tip-title {
      font-size: 14px;
      font-weight: 500;
    }
    .tip-content {
      // margin-top: 5px;
      p {
        font-size: 14px;
        margin: 0;
        color: #333;
      }
    }
  }
}
.operation {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #fe4d45;
  }
}
.buttonBox {
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    // position: absolute;
    // margin-right: 80px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #fe4d45;
    color: #ffffff;
    border-radius: 3px;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
.el-dialog__header span {
  font-size: 16px !important;
  color: #333333 !important;
  width: 64px;
  height: 22px;
  font-weight: 600 !important;
  line-height: 28px;
  opacity: 1;
}
.el-dialog .el-dialog__header {
  background-color: #fff;
  border-bottom: 1px solid #f3f3f3;
}
.el-dialog__body {
  padding: 16px 30px;
}
</style>
<style lang="scss" scope>
/deep/ .el-dialog {
  height: 220px !important;
}
.titileDefinition {
  height: 57px;
  line-height: 57px;
  padding: 0 20px;
  font-size: 20px;
  color: #333333;
  font-weight: bold;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
}
.accountset {
  min-width: 1066px;
  background: #fff;
  // padding: 26px 30px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  border: 1px solid rgba(230, 230, 230, 1);
  box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
  opacity: 1;
  margin: 10px 20px 20px 20px;
  box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
  .global-title-one {
    font-size: 16px;
    color: #2e3458;
    font-weight: bold;
    line-height: 54px;
    padding-left: 28px;
    border-bottom: 1px solid #f0f0f0;
  }
  .head-box {
    //  padding: 24px;
    background: #fffaee;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 10px;
    overflow: hidden;
    font-size: 14px;
    color: #333333;
    margin-top: 20px;
    .head-icon {
      float: left;
      margin-right: 8px;
    }
    .head-content {
      float: left;
      width: 64%;
      line-height: 20px;
      position: relative;
      .icon_i {
        display: inline-block;
        position: absolute;
        width: 14px;
        height: 14px;
        border-radius: 14px;
        background-color: #ffb95e;
        color: #fff;
        font-size: 10px;
        font-weight: bold;
        text-align: center;
        line-height: 14px;
        font-weight: bold;
        top: 3px;
        left: 10px;
      }
      .block {
        width: 800px;
        display: block;
        margin-left: 29px;
      }
    }
  }
  .title {
    width: 84px;
    height: 16px;
    font-size: 16px;
    // font-family: PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
  .line {
    width: 100%;
    height: 1px;
    background: rgba(243, 243, 243, 1);
    border-radius: 1px;
    margin-top: 5px;
  }
  .electricFan {
    height: 110px;
    background: rgba(248, 250, 255, 1);
    border: 1px solid rgba(172, 193, 254, 1);
    border-radius: 2px;
    margin-top: 15px;
    color: #333333;
    padding-left: 52px;
    padding-top: 1%;
    .iconPublic {
      width: 20px !important;
      height: 20px !important;
      display: inline-block;
    }
  }
  .table-box {
    padding: 24px;
    .dot {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      opacity: 1;
      margin-right: 7px;
    }
    .dot-0 {
      background: #49c568;
    }
    .dot-1 {
      background: #ffb95e;
    }
    .dot-2 {
      background: #cccccc;
    }
    .dot-3 {
      background: #fe4d45;
    }
    .item {
      margin-bottom: 15px;
      display: inline-block;
      vertical-align: middle;
      color: #666;
      font-size: 14px;
      margin-right: 42px;
      .item-name {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        display: inline-block;
      }
      .long-input {
        width: 150px;
        display: inline-block;
      }
    }
  }
  .dialog-wrapper {
    .item {
      margin: 8px 0;
      .item-title {
        width: 200px;
      }
      .input {
        display: inline-block;
        vertical-align: middle;
        width: 330px;
      }
    }
    .remarks {
      margin-top: 20px;
      width: 400px;
      height: 44px;
      background: #fafafa;
      opacity: 1;
      line-height: 44px;
    }
    .remarksOne {
      padding: 10px;
      margin-top: 20px;
      width: 400px;
      // height: 80px;
      background: #fafafa;
      opacity: 1;
      // line-height: 44px;
      .boxText {
        // float: left;
        margin: -14px 0 0 20px;
      }
      .icon_i {
        display: inline-block;
        // position: absolute;
        width: 14px;
        height: 14px;
        border-radius: 14px;
        background-color: #ffb95e;
        color: #fff;
        font-size: 10px;
        font-weight: bold;
        text-align: center;
        line-height: 14px;
        font-weight: bold;
        // top: 3px;
        // left: 10px;
      }
    }
  }
}
</style>
